import {
  useAppContext,
  useAuth,
  useAuthentication,
  useShallow,
} from "application";
import { MouseEvent, useRef } from "react";
import { useRouter } from "next/router";

const useUserAuthenticationBox = () => {
  const router = useRouter();
  const { isOpenedDropdownUser, setIsOpenedDropdownUser, isClientMobile } =
    useAppContext();
  const { isAuthenticated, userData } = useAuth();
  const { setIsAuthenticationDropdownActive } = useAuthentication(
    useShallow((state) => ({
      setIsAuthenticationDropdownActive:
        state.setIsAuthenticationDropdownActive,
    }))
  );

  const ModalAuthRef = useRef<HTMLElement>(null);

  const handleOpenDropdownUserAuthenticated = () => {
    if (isClientMobile) {
      return;
    }

    // eslint-disable-next-line no-restricted-globals
    event?.preventDefault();
    setIsOpenedDropdownUser((state) => !state);
  };

  const openLoginModal = (event: MouseEvent<HTMLDivElement>, path?: string) => {
    if (isClientMobile) {
      router.push(path || "/login");
      return;
    }

    event?.preventDefault();
    event?.stopPropagation();
    setIsAuthenticationDropdownActive(true);
  };

  const handleUserMenu = (event: MouseEvent<HTMLDivElement>) => {
    if (isClientMobile) {
      return;
    }

    openLoginModal(event);
  };

  return {
    handleOpenDropdownUserAuthenticated,
    openLoginModal,
    handleUserMenu,
    ModalAuthRef,
    userData,
    isClientMobile,
    isOpenedDropdownUser,
    isAuthenticated,
  };
};

export { useUserAuthenticationBox };
